import React, { useState } from 'react';
import { IconButton, Menu, withStyles } from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import StyledToolTip from '../../../../common/StyledToolTip';
import { compose } from 'recompose';
import { withAppConfig } from '../../../../../appConfigContext';
import ToggleRouteControl from './ToggleRouteControl';
const styles = (theme) => ({
  headerStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    border: `1px solid ${theme.AppBGColor}`,
    marginBottom: 1,
    borderRadius: '4px 4px 0 0',
    fontSize: theme.headerTextFontSize,
    lineHeight: '16px',
    color: theme.HeaderSelectedText
  },
  label: {
    marginLeft: 6,
    width: '90%'
  },
  mainMenu: {
    background: theme.gridBGColor,
    borderRadius: '0px 0px 4px 4px',
    marginTop: '30px',
    overflow: 'inherit'
  },
  mainMenuStyle: {
    display: 'flex',
    flexDirection: 'column',
    padding: '12px 0px',
    width: '200px'
  },
  toggledMenu: {
    display: 'inline'
  },
  mainMenuButton: {
    padding: '9px',
    color: theme.HeaderSelectedText
  }
});
const MapHeader = ({
  classes,
  showActualRoute,
  toggleShowActualRoute,
  showMapLegend,
  toggleShowMapLegend,
  configJSON,
  showPlannedRoute,
  toggleShowPlannedRoute
}) => {
  const [mainMenuAnchor, setMainMenuAnchor] = useState(null);
  const openMainMenu = (event) => {
    setMainMenuAnchor(event.currentTarget);
  };

  const closeMainMenu = () => {
    setMainMenuAnchor(null);
  };
  return (
    <div className={classes.headerStyle}>
      <span className={classes.label}>Route Map</span>
      <div className={classes.toggledMenu}>
        <IconButton color="inherit" className={classes.mainMenuButton} onClick={openMainMenu}>
          <StyledToolTip title="Show Controls">
            <MoreVert style={{ fontSize: '21px' }} />
          </StyledToolTip>
        </IconButton>
      </div>
      <div>
        <Menu
          disablePortal
          getContentAnchorEl={null}
          disableAutoFocusItem
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          open={Boolean(mainMenuAnchor)}
          keepMounted
          anchorEl={mainMenuAnchor}
          onClose={closeMainMenu}
          MenuListProps={{ disablePadding: true }}
          classes={{
            paper: classes.mainMenu
          }}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
          <div className={classes.mainMenuStyle}>
            {configJSON?.enableDriverActualRoute && (
              <ToggleRouteControl
                isChecked={showActualRoute}
                onToggle={toggleShowActualRoute}
                controlType="Actual Route"
              />
            )}
            <ToggleRouteControl
              isChecked={showMapLegend}
              onToggle={toggleShowMapLegend}
              controlType="Map Legend"
            />
            <ToggleRouteControl
              isChecked={showPlannedRoute}
              onToggle={toggleShowPlannedRoute}
              controlType="Planned Route"
            />
          </div>
        </Menu>
      </div>
    </div>
  );
};

export default compose(withStyles(styles), withAppConfig)(MapHeader);
